var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-4 my-4"},[_c('div',{staticClass:"text-h5"},[_vm._v("Tableau de bord")]),_c('Statistique')],1)}
var staticRenderFns = []

export { render, staticRenderFns }